export var FLUENT_CDN_BASE_URL = 'https://res.cdn.office.net/files/fabric-cdn-prod_20251107.003';
//# sourceMappingURL=cdn.js.map